import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";
import { applyUiThemeToDocument, readStoredTheme } from "./theme/uiTheme";
import "./styles.css";

// Apply the persisted theme before the first render so the user does not see
// a flash of the default theme when Mac OS 8 is selected.
applyUiThemeToDocument(readStoredTheme());

const container = document.getElementById("root");
if (!container) {
  throw new Error("Root container missing in index.html");
}

ReactDOM.createRoot(container).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
